import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
  },
  input: {
    border: `1px solid ${theme.colors.border1}`,
    borderRadius: theme.radius.small,
    minHeight: 48,
    boxSizing: "border-box",
    paddingInlineStart: theme.spacing.space12,
    paddingInlineEnd: theme.spacing.space32,
    background: "transparent",
    outline: "none",
    "&:focus": {
      border: `1px solid ${theme.colors.border4}`,
    },
    color: theme.colors.text1,
    caretColor: theme.colors.primary,
    fontWeight: theme.fontWeight.semiBold,
    fontSize: 16,
    lineHeight: "24px",
  },
  textarea: {
    paddingInlineEnd: theme.spacing.space12,
  },
  fullWidth: {
    width: "100%",
  },
  startAdornment: {
    marginInlineEnd: theme.spacing.space8,
    position: "absolute",
    insetInlineStart: theme.spacing.space12,
    display: "flex",
    alignItems: "center",
    color: theme.colors.text4,
  },
  content: {
    position: "relative",
    cursor: "text",
    display: "flex",
    fontSize: 15,
    alignItems: "center",
    fontFamily: theme.fontFamily,
    margin: `${theme.spacing.space4}px 0px`,
  },
  fitContent: {
    width: "fit-content",
  },
  hasStartIcon: {
    paddingInlineStart: theme.spacing.space40,
  },
  hasClearIcon: {
    paddingInlineEnd: theme.spacing.space40,
  },
  closeIcon: {
    position: "absolute",
    insetInlineEnd: theme.spacing.space12,
    cursor: "pointer",
    color: theme.colors.text4,
  },
  errorBorder: {
    border: `1px solid ${theme.colors.error} !important`,
  },
  textDisable: {
    color: theme.colors.text4,
    background: theme.colors.background4,
  },
  endAdornment: {
    position: "absolute",
    insetInlineEnd: theme.spacing.space4,
    cursor: "pointer",
    display: "flex",
  },
  dangerIcon: {
    fontSize: "14px !important",
    color: theme.colors.text2,
    "&.error": {
      color: theme.colors.error,
    },
  },
}));
